import { Component, OnInit } from '@angular/core';
import { ProductActiveStockItem } from '../../../../../core/api/products/entities/product-active-stock-item.entity';
import { ProductActionType } from '../../../../../core/enums/product-actions/product-action-type.enum';
import { QuickActionForms } from '../../../../../core/models/dashboard-forms.model';
import { DashboardService } from '../../../../../core/services/dashboard.service';
import { QuickActionForm } from '../../../../../forms/forms/quick-action.form';
import { DashboardActionDialogComponent } from '../dashboard-action-dialog/dashboard-action-dialog.component';

@Component({
  selector: 'app-dashboard-quick-action-dialog',
  templateUrl: './dashboard-quick-action-dialog.component.html',
  styleUrl: './dashboard-quick-action-dialog.component.scss',
})
export class DashboardQuickActionDialogComponent extends DashboardActionDialogComponent implements OnInit {
  productActionTypes = Object.values(ProductActionType).filter(value => value !== ProductActionType.Purchase);
  showErrors = false;

  constructor(service: DashboardService) {
    super(service);
  }

  ngOnInit(): void {
    if (this.productActionType === ProductActionType.Purchase) {
      this.setProductActionType(ProductActionType.Consume);
    }
  }

  get form(): QuickActionForm<any> {
    switch (this.productActionType) {
      case ProductActionType.Consume:
        return this.quickActionForms.consume;
      case ProductActionType.Transfer:
        return this.quickActionForms.transfer;
      default:
        return this.quickActionForms.open;
    }
  }

  get isConsume(): boolean {
    return this.productActionType === ProductActionType.Consume;
  }

  get isLoading(): boolean {
    return this.service.state.isLoading;
  }

  get isSubmitting(): boolean {
    return this.service.state.isSubmitting;
  }

  get isTransfer(): boolean {
    return this.productActionType === ProductActionType.Transfer;
  }

  get quickActionForms(): QuickActionForms {
    return this.forms.quickAction;
  }

  get stockItems(): ProductActiveStockItem[] {
    return this.service.product?.activeStockItems || [];
  }

  submit(): void {
    this.service.submitQuickAction(this.form.productAction).subscribe();
  }

  getStockEntryDisplayValue(stockItem: ProductActiveStockItem): string {
    let stockEntryDisplayValue = `${stockItem.amount}`;

    if (stockItem.amount === 1) {
      stockEntryDisplayValue += ` ${this.form.quantityUnit?.name}`;
    } else {
      stockEntryDisplayValue += ` ${this.form.quantityUnit?.namePlural}`;
    }

    if (stockItem.openedAt) {
      stockEntryDisplayValue += ' (opened) ';
    }

    stockEntryDisplayValue += ` · ${stockItem.locationName}`;

    return stockEntryDisplayValue;
  }
}
